<div class="my-3">
  <div
    [class.custom-scroll]="dynamicHeight"
    [style.max-height.vh]="dynamicHeight ? dynamicHeight : null"
  >
    @for (checklist of checkListData; track checklist; let i = $index) {
      <div class="p-2 p-lg-3 border rounded mb-2">
        <div
          (click)="openIndex = i; normalizeTaskList(checklist?.tasks)"
          [id]="'checklistId' + i"
        >
          @if (checkListData?.length > 1) {
            <div
              class="d-flex gap-2 align-items-center mb-2 justify-content-between"
            >
              <div class="w-25">
                <dt>Order</dt>
                <input
                  type="tel"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  class="form-control"
                  list="numbers"
                  [min]="1"
                  [max]="checkListData?.length"
                  [value]="i + 1"
                  (change)="onPositionChange(i, $event)"
                />
                <datalist id="numbers">
                  @for (number of checkListDataIndexList; track number) {
                    <option [value]="number">
                      {{ number }}
                    </option>
                  }
                </datalist>
              </div>
              <button
                (click)="
                  checkListData?.splice(i, 1);
                  $event.stopImmediatePropagation();
                  openIndex == i ? (openIndex = openIndex - 1) : (openIndex = 0)
                "
                class="btn btn-outline-danger btn-sm"
              >
                Delete
              </button>
            </div>
          }

          @if (checklist?.site?.id) {
            <div class="p-2" id="site-details-section">
              <div
                class="link-edit"
                (click)="editSiteField(checklist, 'siteId' + i)"
              >
                <span class="fw-semibold">{{
                  checklist?.site?.company_name
                }}</span>
                [{{ checklist?.site?.company?.company_name }}]
                <div class="small fw-normal mb-2">
                  {{
                    checklist?.site?.full_address ||
                      checklist?.site?.address?.full_address
                  }}
                </div>
              </div>
            </div>
          }

          <div
            class="d-flex align-items-center justify-content-between gap-2 py-2"
          >
            <div class="d-flex gap-2 flex-column flex-lg-row">
              @if (userPromptTotalCount > 0) {
                <div>
                  <button
                    (click)="
                      openTemplate(addPromptTemplate, 'prompts', checklist)
                    "
                    class="btn"
                    [ngClass]="
                      getPromptsInCheckList(checklist)
                        ? 'btn-primary'
                        : 'btn-outline-primary'
                    "
                  >
                    Add Mobile Form
                  </button>
                </div>
              }
              @if (
                checklist?.site?.cp_count &&
                checklist?.enable_reporting &&
                checklist?.site?.id
              ) {
                <div>
                  <button
                    (click)="onAddCheckpointsToRoute(checklist)"
                    class="btn"
                    [ngClass]="
                      checklist?.selectedCheckpoints?.length
                        ? 'btn-primary'
                        : 'btn-outline-primary'
                    "
                  >
                    {{
                      checklist?.selectedCheckpoints?.length
                        ? "Edit Checkpoints"
                        : "Include Checkpoint Scans"
                    }}
                  </button>
                </div>
              }
              @if (
                (checklist?.site?.site_information ||
                  checklist?.site?.information) &&
                openIndex == i
              ) {
                <div>
                  <button
                    (click)="
                      checklist.site.showSiteInfo =
                        !checklist?.site?.showSiteInfo
                    "
                    class="btn"
                    [ngClass]="
                      checklist.site.showSiteInfo
                        ? 'btn-primary'
                        : 'btn-outline-primary'
                    "
                  >
                    Site Info
                  </button>
                </div>
              }
              @if (checklist?.site?.hasSiteKeys && openIndex == i) {
                <div>
                  <button
                    (click)="
                      checklist.site.showSiteKeys =
                        !checklist?.site?.showSiteKeys
                    "
                    class="btn"
                    [ngClass]="
                      checklist.site.showSiteKeys
                        ? 'btn-primary'
                        : 'btn-outline-primary'
                    "
                  >
                    Site Keys
                  </button>
                </div>
              }
            </div>
            @if (checklist?.site?.id) {
              <div
                class="form-check d-flex align-items-center justify-content-end gap-2 py-2"
              >
                <input
                  [checked]="!checklist?.enable_reporting"
                  (change)="
                    checklist.enable_reporting = !checklist?.enable_reporting;
                    checklist.selectedCheckpoints = []
                  "
                  class="form-check-input cursor-pointer"
                  type="checkbox"
                  [id]="'reportId' + i"
                />
                <label
                  class="form-check-label cursor-pointer"
                  [for]="'reportId' + i"
                  [class.fw-bold]="!checklist?.enable_reporting"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  [attr.title]="'Does not allow reporting or invoicing features.'"
                >
                  Basic Checklist Only
                </label>
                <span
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  [attr.title]="'Does not allow reporting or invoicing features.'"
                >
                  <i class="fa-solid fa-circle-info text-secondary"></i>
                </span>
              </div>
            }
          </div>

          @if (!checklist?.site?.id) {
            @if (openIndex === i) {
              <div class="mb-2">
                <gtapp-auto-complete
                  [data]="siteList"
                  placeHolder="Site (Optional)"
                  searchKeyword="company_name"
                  [itemTemplate]="siteTemplate"
                  [addInitialKey]="true"
                  (inputChanged)="onSiteSearch($event)"
                  (selected)="onSelectSite($event, checklist, i)"
                  [enableCloseOption]="true"
                  (fieldCleared)="editSiteField(checklist, 'siteId' + i)"
                  [inputId]="'siteId' + i"
                >
                </gtapp-auto-complete>
              </div>
              <ng-template #siteTemplate let-item>
                @if (item?.key === 0) {
                  <div>Create New Site</div>
                } @else {
                  <div>
                    <div class="fw-medium">
                      {{ item?.company_name }} [{{
                        item?.company?.company_name
                      }}]
                    </div>
                    <div class="small-font text-secondary">
                      {{ item?.address?.full_address }}
                    </div>
                  </div>
                }
              </ng-template>
            } @else {
              <div class="fw-semibold text-secondary">Tasks w/o Site</div>
            }
          }
          <div class="text-center pt-3">
            @if (openIndex !== i) {
              <button class="btn btn-outline-secondary btn-sm">
                See Details
              </button>
            }
          </div>
        </div>
        @if (openIndex == i) {
          @if (checklist?.site?.id) {
            <div class="p-2">
              <!--site information-->
              @if (checklist?.site?.showSiteInfo) {
                <div class="mb-3">
                  <dt>Site Information</dt>
                  <dd class="gt-multi-line">
                    {{
                      checklist?.site?.site_information ||
                        checklist?.site?.information
                    }}
                  </dd>
                </div>
              }
              <gtapp-site-keys
                [class.d-none]="!checklist?.site?.showSiteKeys"
                [selectedSite]="checklist?.site"
                [showManageOption]="false"
                (updateSiteInfo)="checklist.site.hasSiteKeys = $event?.length"
              ></gtapp-site-keys>
            </div>
          }

          @for (task of checklist?.tasks; track task; let subIndex = $index) {
            <div class="mb-2">
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  @if (task?.user_prompt_id) {
                    <div
                      class="p-2 border rounded bg-secondary-subtle d-flex align-items-center gap-3"
                    >
                      <i class="fa-solid fa-clipboard-list text-success"></i>
                      <div class="fw-semibold text-dark">
                        {{ task.note }}
                      </div>
                    </div>
                  } @else {
                    <textarea
                      class="form-control"
                      placeholder="Task Description"
                      [ngStyle]="task?.ngStyle"
                      [(ngModel)]="task.note"
                      (input)="onInputTaskNote($event, task, checklist?.tasks)"
                      rows="2"
                    ></textarea>
                  }
                </div>
                @if (task?.note) {
                  <div class="d-flex gap-3 ps-3 flex-row">
                    @if (checklist?.tasks?.length > 1) {
                      <span (click)="checklist?.tasks?.splice(subIndex, 1)">
                        <i class="fa fa-close text-secondary fa-2x"></i>
                      </span>
                    }
                    <span (click)="duplicateTask(checklist?.tasks, subIndex)">
                      <i class="fa-regular fa-copy text-secondary fa-2x"></i>
                    </span>
                    <span
                      (click)="
                        openTaskConfigTemplate(
                          checklist?.tasks,
                          task,
                          taskReminderTemplate
                        )
                      "
                    >
                      @if (!task?.schedule) {
                        @if (
                          schedulerForm?.value?.repeat_type == "once" ||
                          schedulerForm?.value?.id
                        ) {
                          <span>
                            <i
                              class="fa-solid fa-bell fa-2x text-secondary"
                            ></i>
                          </span>
                        } @else {
                          <span>
                            <i class="fa-solid fa-cog fa-2x text-secondary"></i>
                          </span>
                        }
                      }
                    </span>
                  </div>
                }
              </div>
              @if (task?.schedule) {
                <div class="p-2 rounded d-flex align-items-center mb-3">
                  <div class="flex-grow-1">
                    @if (task?.schedule?.repeat_details?.length) {
                      <span class="text-secondary"> Task Limited To: </span>
                      {{ task?.schedule?.repeat_details }}
                    }
                    @if (task?.schedule?.reminder) {
                      <span class="text-secondary"> Reminder Set:</span>
                      @if (task?.schedule?.start_datetime) {
                        {{ task?.schedule | misc: "runsheetTaskTiming" }}
                      } @else if (task?.schedule?.start_time) {
                        {{ task?.schedule?.start_time }}
                      }
                    }
                  </div>
                  <div class="d-flex gap-2">
                    <span
                      (click)="
                        openTaskConfigTemplate(
                          checklist?.tasks,
                          task,
                          taskReminderTemplate
                        )
                      "
                    >
                      <i
                        class="fa-solid fa-pen-to-square text-secondary fs-4"
                      ></i>
                    </span>
                    <span (click)="task.schedule = null">
                      <i class="fa fa-trash text-secondary fs-4"></i>
                    </span>
                  </div>
                </div>
              }
            </div>
          }

          <!-- @if (userPromptTotalCount > 0) {
          <div class="p-3">
            <dt>Mobile Forms</dt>
            @if (userPromptTotalCount > 3) {
              <div>
                <gtapp-auto-complete
                  [data]="userPromptsSearchResults"
                  inputId="promptSelectId"
                  placeHolder="Search Mobile Forms"
                  searchKeyword="name"
                  [itemTemplate]="promptLookupTemplate"
                  (inputChanged)="searchPrompts($event)"
                  (selected)="addPromptTask($event, checklist)"
                >
                </gtapp-auto-complete>
              </div>
              <ng-template #promptLookupTemplate let-item>
                <div class="fw-bold">
                  {{ item?.name }}
                </div>
              </ng-template> -->

          <!-- <div class="text-end">
            <button
              class="btn btn-primary btn-sm"
              (click)="openTemplate(promptTemplate, checklist?.tasks)"
            >
              Add Mobile Form
            </button>
          </div> -->
          <!-- }

            <div class="d-flex gap-2 my-2 flex-wrap">
              @for (prompt of userPromptsSearchResultsCopy; track prompt?.id) {
                <div
                  role="button"
                  (click)="addPromptTask(prompt, checklist)"
                  class="p-2 border rounded bg-secondary-subtle d-flex align-items-center justify-content-between gap-3 hover"
                >
                  <i class="fa-solid fa-clipboard-list text-success"></i>
                  <div class="fw-semibold small text-dark">
                    {{ prompt?.name }}
                  </div>
                </div>
              }
            </div>
          </div>
        } -->
        }
      </div>
    }
  </div>

  @if (
    checkListData[checkListData?.length - 1]?.enable_reporting ||
    checkListData[checkListData?.length - 1]?.tasks?.[0]?.note
  ) {
    <div class="py-4">
      <button
        (click)="filterEmptyTasks()"
        class="btn btn-lg btn-outline-primary w-100"
        id="addPatrolButton"
        role="button"
      >
        Add Patrol
      </button>
    </div>
  }
</div>

<ng-template
  #taskReminderTemplate
  let-taskReminderTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header mb-0">
      {{
        schedulerForm?.value?.repeat_type == "once" || schedulerForm?.value?.id
          ? "Set Task Reminder"
          : " Configure Task"
      }}

      <span class="float-end" (click)="taskReminderTemplateRef.close(false)">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div class="mb-3">
      <div class="row row-cols-1 g-2 mb-4">
        @if (data?.schedule?.showItems.startEndDateTime) {
          <div
            class="form-floating"
            [class.opacity-75]="data?.schedule?.repeat_details?.length"
          >
            <input
              id="startDay"
              class="form-control"
              type="datetime-local"
              placeholder="Pick Reminder Date & Time*"
              [(ngModel)]="data.schedule.start_datetime"
              step="900"
              [min]="data?.schedule?.minDateTime"
              [max]="data?.schedule?.maxDateTime"
              (change)="
                changeStartEndDateTime(
                  $event,
                  data?.schedule,
                  'start_datetime',
                  'startDateTime'
                )
              "
              [class.is-invalid]="data?.schedule?.invalid?.startDateTime"
            /><label for="startDay"> Reminder Date & Time*</label>
          </div>
        }
        @if (data?.schedule?.showItems.startEndTime) {
          <div class="form-floating col-6">
            <input
              type="time"
              class="form-control"
              id="startTime"
              placeholder="Reminder Time*"
              [(ngModel)]="data.schedule.start_time"
              step="900"
              (change)="
                changeStartEndDateTime(
                  $event,
                  data?.schedule,
                  'start_time',
                  'startTime'
                )
              "
              [class.is-invalid]="data?.schedule?.invalid?.startTime"
            />
            <label for="startTime" class="form-label">Reminder Time*</label>
          </div>
        }
      </div>
      @if (data?.schedule?.availableDays?.length) {
        <div
          [class.opacity-75]="
            !data?.schedule?.repeat_details?.length &&
            data?.schedule?.showItems.startEndDateTime
          "
        >
          @if (data?.schedule?.showItems.startEndDateTime) {
            <div class="text-center fw-semibold">OR</div>
          }
          <dl>
            <dt>Perform Task Only On Certain Weekdays</dt>
            <dd>
              <div class="d-flex column-gap-5 row-gap-4 flex-wrap p-3">
                @for (
                  day of data?.schedule?.availableDays;
                  track day;
                  let i = $index
                ) {
                  <div>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="check-{{ i }}"
                      [checked]="data?.schedule?.repeat_details?.includes(day)"
                      (change)="selectWeekDays(data?.schedule, day)"
                    />
                    <label class="form-check-label ms-1" for="check-{{ i }}">
                      {{ day }}
                    </label>
                  </div>
                }
              </div>
            </dd>
          </dl>
          <div class="row row-cols-1 g-2">
            <div class="d-flex gap-2 align-items-center">
              <div class="form-check ms-2 mb-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="checkDefault"
                  [checked]="data?.schedule?.reminder"
                  (change)="data.schedule.reminder = !data?.schedule?.reminder"
                />
              </div>
              <label class="form-check-label" for="checkDefault">
                Set Task Reminder
              </label>
            </div>
            @if (data?.schedule?.reminder) {
              <div class="form-floating col-6">
                <input
                  type="time"
                  class="form-control"
                  id="startTime"
                  placeholder="Reminder Time*"
                  step="900"
                  [(ngModel)]="data.schedule.start_time"
                  (change)="
                    changeStartEndDateTime(
                      $event,
                      data?.schedule,
                      'start_time',
                      'startTime',
                      true
                    )
                  "
                  [class.is-invalid]="data?.schedule?.invalid?.startTime"
                />
                <label for="startTime" class="form-label">Reminder Time*</label>
              </div>
              <div class="small-font text-secondary">
                * Reminders can only be set at quarter hour marks
              </div>
            }
          </div>
        </div>
      }
    </div>

    <div class="row row-cols-2">
      <div class="col">
        <button
          class="btn btn-light btn-lg w-100"
          (click)="taskReminderTemplateRef.close(false)"
        >
          Clear
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          [disabled]="
            data?.schedule?.invalid?.startTime ||
            data?.schedule?.invalid?.endTime ||
            data?.schedule?.invalid?.startDateTime ||
            data?.schedule?.invalid?.endDateTime
          "
          (click)="taskReminderTemplateRef.close(data)"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #addPromptTemplate let-addPromptTemplateRef="dialogRef" let-data>
  <div class="dialog-box card">
    <div class="card-header mb-0">
      Add Mobile Form
      <span class="float-end" (click)="addPromptTemplateRef.close(false)">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div class="my-4">
      @if (userPromptTotalCount > 3) {
        <div>
          <gtapp-auto-complete
            [data]="userPromptsSearchResults"
            inputId="promptSelectId"
            placeHolder="Search Mobile Forms"
            searchKeyword="name"
            [itemTemplate]="promptLookupTemplate"
            (inputChanged)="searchPrompts($event)"
            (selected)="
              addPromptTask($event, data); addPromptTemplateRef.close(true)
            "
          >
          </gtapp-auto-complete>
        </div>
        <ng-template #promptLookupTemplate let-item>
          <div class="fw-bold">
            {{ item?.name }}
          </div>
        </ng-template>
      }

      <div class="d-flex gap-2 my-2 flex-wrap">
        @for (prompt of userPromptsSearchResultsCopy; track prompt?.id) {
          <div
            (click)="
              addPromptTask(prompt, data); addPromptTemplateRef.close(true)
            "
            role="button"
            class="p-2 border rounded bg-secondary-subtle d-flex align-items-center justify-content-between gap-3 hover"
          >
            <i class="fa-solid fa-clipboard-list text-success"></i>
            <div class="fw-semibold small text-dark">
              {{ prompt?.name }}
            </div>
          </div>
        }
      </div>
    </div>
    <!-- <div class="mb-5 text-end text-secondary small">
      Added Mobile Forms: {{ getPromptsInCheckList(data) }}
    </div>
    <div class="row row-cols-2">
      <div class="col">
        <button
          class="btn btn-light btn-lg w-100"
          (click)="addPromptTemplateRef.close(false)"
        >
          Clear
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          (click)="addPromptTemplateRef.close(true)"
        >
          Submit
        </button>
      </div>
    </div> -->
  </div>
</ng-template>
